<template>

  <t-page>

    <StepActionDialog @onSubmit="onSubmitStepAction" :type="modalActionType"
                      :production-order-batch-step-id="modalActionStepId"/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" msg-return-gender-feminine
                 title-items="Ordens de Fabricação"
                 @getPage="getPage">

      <template #search>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Cód. Ordem de Fabricação"
                                         big-search
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <slot name="search-header"></slot>

          <slot name="search-default">

            <t-input-search v-if="relationAccessSubValidation('sub-production-step-enable-list-all')"
                            class="alert-warning p-1 pb-0 mb-2"
                            small="Habilitado, pois você possui acesso a listagem completa" v-model="form.groupUserId"
                            :options="groupUserOptions"
                            label="Responsável"
                            select/>


            <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

          </slot>

          <slot name="search-footer">

            <b-row>

              <t-input-search cols="4" v-model="form.groupProductId"
                              :options="groupProductOptions"
                              label="Grupo"
                              select/>


              <b-col cols="4">

                <t-input-code-label model label="Modelo" v-model="form.modelId" />

              </b-col>

              <t-input-search cols="4" label="Embalagem" v-model="form.unitId" :options="unitOptions" select/>

            </b-row>


          </slot>

          <b-row>

            <t-input cols="4" v-model="form.processFlowStepId" :options="stepOptions"
                     label="Etapa" select/>

            <t-input-search v-model="form.operationStatusId"
                            :options="typeStatusProductionOptions"
                            label="Status Operacional" cols="4"
                            select/>

            <t-input-search v-model="form.statusExecution"
                            :options="statusExecutionOptions"
                            label="Status Execução" cols="4"
                            radio/>

          </b-row>




        </t-content-header-search-default>

      </template>


      <t-table :show="checkViewListTableDefault()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="productionOrderCodeLabel"
               primary-key-column="productionOrderBatchStepId">

        <!-- TEMPLATES QUE NÃO FORAM ESPECIFICADOS E PODEM SER UTILIZADOS, INCLUINDO CAMPOS CUSTOMIZADOS 'item(field_000)' -->
        <template v-for="field in getViewFields(itemSlotsDefault)" v-slot:[mountTemplate(field)]="{item}">
          <slot :name="'item(' + field.key + ')'" :item="item">
            <t-table-field :column="field.key" :formatter="field.formatter" :item="item"/>
          </slot>
        </template>

        <!-- TEMPLATES PRÉ-DETERMINADOS COM FORMATAÇÃO, PORÉM PODERÃO SER SOBREPOSTOS TAMBÉM-->
        <template #item(statusExecution)="{item}">
          <slot name="item(statusExecution)" :item="item">
            <span v-if="item.statusExecution === 1">Em execução</span>
            <span v-else>Aguardando início</span>
          </slot>
        </template>

        <template #item(statusBatch)="{item}">
          <slot name="item(statusBatch)" :item="item">
            <ProductionStatusBadge :status="item.statusBatch"/>
          </slot>
        </template>

        <template #item(name)="{item}">
          <slot name="item(name)" :item="item">

            <b-icon-bezier v-if="item.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL" v-b-tooltip.hover.ds500 title="Etapa em paralelo disponível para finalização"/>
            <b-icon-bezier2 v-else v-b-tooltip.hover.ds500 title="Etapa atual"/>

            {{ item.name }}

          </slot>
        </template>

        <template #item(responsibleName)="{item}">

          {{item.responsibleName}}

          <div v-if="relationAccessSubValidation('sub-production-step-change-responsibility')">
            <b-link @click="stepActionSetResponsible(item.productionOrderBatchStepId,'set_groupUser')">Alterar?</b-link>
          </div>

        </template>


        <template #item(operator)="{item}">

          <slot name="item(operator)" :item="item">

            <div v-if="item.operatorId === 0">

              <small>Sem operador</small>

              <div v-if="relationAccessSubValidation('sub-production-step-change-responsibility')">
                <b-link @click="stepActionSetResponsible(item.productionOrderBatchStepId,'set_responsible')">Alterar?</b-link>
              </div>

            </div>

            <div v-else>

              <span>{{ item.operator }}</span>

              <div v-if="relationAccessSubValidation('sub-production-step-change-responsibility')">
                <b-link @click="stepActionSetResponsible(item.productionOrderBatchStepId)">Alterar?</b-link>
              </div>

            </div>

          </slot>

        </template>

        <template #append-actions="{item}">
          <slot name="append-actions" :item="item"></slot>
        </template>

        <template #item(statusProduction)="{item}">
          <slot name="item(statusProduction)" :item="item">
            <div class="d-flex align-items-center"
                 v-if="item.statusBatch === StatusProductionOrderType.type.PRODUCTION">
              <span v-if="item.statusProductionColor !== ''" class="badge badge-dot badge-dot-xl mr-2"
                    :style="{'background-color': item.statusProductionColor}"></span> {{ item.statusProduction }}
            </div>
            <span v-else></span>
          </slot>
        </template>

        <template #actions="{item}">

          <slot name="actions" :item="item">

            <b-button
                v-if="item.pdfReportId && item.pdfReportId > 0 && relationAccessSubValidation('sub-production-step-order-detail')"
                v-b-tooltip.hover.ds500 title="Gerar PDF"
                @click="downloadReport(item.pdfReportId, item.productionOrderId, item.productionOrderCodeLabel)"
                size="sm" variant="outline">
              <b-icon-file-pdf variant="primary"></b-icon-file-pdf>
            </b-button>

          </slot>

        </template>


      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import http from "@/services/config/http-common";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import ProductionStatusBadge from "@/views/modules/production/ProductionOrder/components/ProductionStatusBadge";
import StepActionDialog from "@/views/modules/production/ProductionOrder/components/StepActionDialog";
import ui from "@/assets/scripts/ui";
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import StatusStepType from "@/model/types/modules/production/StatusStepType";

export default {
  components: {ProductionStatusBadge, StepActionDialog},
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'ProductionOrderStepEmbeddable',
  data() {
    return {
      FlowStepNotSequenceActionType,
      itemSlotsDefault: ["statusExecution", "operator", "statusBatch"], /*Listagem de nomes de slotes que já foram declarados no padrão #item(X)*/
      StatusProductionOrderType,
      StatusStepType,
      path: "production/order-step", //Utilizar somente quando fora do padrão
      enableGeneralFields: false,
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalActionType: "",
      modalActionStepId: 0,
      statusExecutionOptions: [{value: "1", text: "Em execução"}, {value: "2", text: "Aguardando início"}],
      groupProductOptions: [],
      unitOptions: [],
      groupUserOptions: [],
      stepOptions: [],
      typeStatusProductionOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    pathOrder: {
      type: String,
      default: "production/order", //Caminho para visualização da Ordem de Produção, por padrão é a mesmo do template
    }

  },
  methods: {

    mountTemplate(slot) {
      return "item(" + slot.key + ")"
    },

    mountedPrepare() {

      this.setValue(this.value)


      //Remove status padrão da busca


    },
    async mountedContinued() {

      this.pageListIsLoaded = false

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.groupProductOptions = response.groupProductOptions
        this.unitOptions = response.unitOptions
        this.groupUserOptions = response.groupUserOptions
        this.typeStatusProductionOptions = response.typeStatusProductionOptions
        //this.stepOptions = response.stepOptions //Somente as etapas que podem ser visualizadas pelo usuário e que estão pendentes
      }).catch(error => this.responseError(error))

      await ProcessFlowStepService.selectList(0, true)
          .then(list => this.stepOptions = list)
          .catch(error => this.responseError(error))


      this.$emit("mounted", this.userAuth)

      this.pageListIsLoaded = true

    },
    afterGetPage() {


      for (let item of this.request.content) {
        if (item.statusBatch === StatusProductionOrderType.type.STOPPED_PRODUCTION) {
          item.class = 'table-danger'
        } else if (item.typeActionNotSequential === FlowStepNotSequenceActionType.type.EXECUTION_PARALLEL) {
          item.class = 'bg-focus-light'
        }
      }

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    setValue(v) {
      this.form = v
    },

    stepActionSetResponsible(id,type) {

      this.modalActionType = type
      this.modalActionStepId = id
      this.openDialogForm('modal-action-step')

    },


    async onSubmitStepAction() {

      await this.getPage()
      ui.toast(this, "Responsável alterado com sucesso!")

    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
  watch: {
    value(v) {
      this.setValue(v)
    },
    form(v) {
      this.$emit("input", v)
    }
  }
}
</script>
